var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24967 20.1673H13.7497C18.333 20.1673 20.1663 18.334 20.1663 13.7507V8.25065C20.1663 3.66732 18.333 1.83398 13.7497 1.83398H8.24967C3.66634 1.83398 1.83301 3.66732 1.83301 8.25065V13.7507C1.83301 18.334 3.66634 20.1673 8.24967 20.1673Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.848 13.998V6.94879C16.848 6.24296 16.2797 5.72963 15.583 5.78463H15.5464C14.3181 5.88547 12.4572 6.51798 11.4122 7.16881L11.3114 7.23298C11.1464 7.33382 10.8622 7.33382 10.688 7.23298L10.5414 7.14131C9.50554 6.49048 7.64471 5.87629 6.41637 5.77546C5.71971 5.72046 5.15137 6.24298 5.15137 6.93964V13.998C5.15137 14.5571 5.60969 15.0888 6.16885 15.153L6.33385 15.1805C7.59885 15.3455 9.56056 15.9963 10.6789 16.6105L10.7064 16.6196C10.8622 16.7113 11.1189 16.7113 11.2655 16.6196C12.3839 15.9963 14.3547 15.3546 15.6289 15.1805L15.8214 15.153C16.3897 15.0888 16.848 14.5663 16.848 13.998Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.42578V16.1891",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookSquare);
export default __webpack_public_path__ + "static/media/book-square.fe8c713ef9063b9ba5e8492420aa63c1.svg";
export { ForwardRef as ReactComponent };